import { SET_FTTB_CATALOG_DATA } from 'pages/FTTB/actions/actionTypes';
import { simpleReducer } from 'utils/reduxHelpers';

export const fttbCatalogData = simpleReducer(SET_FTTB_CATALOG_DATA, {}, (state, action) => ({
  ...state,
  fttbCatalogData: action.payload,
}));
